import axios from "axios";
import Inscription from "@/classes/Booking/BookingInscription.class.js";
import * as custom_hooks from "@/assets/js/hooks.js";

/**
 * @classdesc Une réservation sur un module
 * @kind class
 * @export
 * @prop {Inscription[]} inscriptions - Liste des inscriptions
 * @class Reservation
 */
export default class Reservation {
    id;
    uuid;
    id_module;
    id_account = 0;
    prix = 0;
    prix_total = 0;
    nb_articles = 0;
    taxe = 0;
    exclude_taxe = false;
    is_group = false;
    nom_groupe = "";
    inscriptions = [];
    transaction = {};
    initial_commande_inscription;
    /**
     * Creates an instance of Reservation.
     * @constructs
     * @kind function
     * @memberof Reservation
     */
    constructor(module_id) {
        this.id_module = parseInt(module_id);
    }

    set(data) {
        if (!data) return;
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                if (key == "inscriptions") {
                    this.inscriptions = [];
                    for (let i = 0; i < value.length; i++) {
                        let inscription = new Inscription(this.id_module);
                        inscription.set(value[i]);
                        this.inscriptions.push(inscription);
                    }
                }
                else {
                    this[key] = value;
                }

            }
        }
    }

    /* 
        Lors de l'initialisation de la réservation, on initialise les valeurs par défaut
    */
    initialize(module, account, inscription_groupe) {
        if (!this.id_module) {
            this.id_module = module.id;
        }
        if (module.get_metadata("exclure_taxe") && module.get_metadata("exclure_taxe") == 1) {
            this.exclude_taxe = true;
        }
        if (account && account.id) {
            this.id_account = account.id;
        }
        if (inscription_groupe) {
            this.is_group = true;
            this.nom_groupe = "";
        }
    }

    addInscription() {
        let inscription = new Inscription(this.id_module);
        this.inscriptions.push(inscription);
    }

    /* 
        Gère la préselection d'une course en équipe/duo ou en relais
    */
    handle_preselection_course_plusieurs_coureurs(preselection) {
        if (preselection && preselection.course) {
            // Si la course est une course en équipe ou en relais, on ajoute le nombre de coureurs nécessaires
            if ((preselection.course.type == "relais" || preselection.course.type == "equipe") && preselection.course.metadatas.nb_coureurs_equipe) {
                let nb_coureurs_to_add = preselection.course.metadatas.nb_coureurs_equipe - 1;
                for (let i = 0; i < nb_coureurs_to_add; i++) {
                    this.addInscription();
                }
            }
            // Si la course est une course en duo, on ajoute un coureur
            if (preselection.course.type == "duo") {
                this.addInscription();
            }
        }
    }

    removeInscription(index) {
        this.inscriptions.splice(index, 1);
    }


    /**
     * Calcule le prix total de la réservation
     *
     * @memberof Reservation
     */
    compute_cart(vip_ins = null) {
        this.prix_total = 0;
        this.prix = 0;
        this.nb_articles = 0;
        this.taxe = 0;
        for (let i = 0; i < this.inscriptions.length; i++) {
            this.inscriptions[i].update_cart("courses", vip_ins);
            let cart_for_inscription = this.inscriptions[i].compute_cart();

            this.prix += parseFloat(cart_for_inscription.prix);
            this.nb_articles += parseInt(cart_for_inscription.nb_articles);
        }
        this.prix = parseFloat(this.prix.toFixed(2));

        if (this.initial_commande_inscription) {
            this.apply_remise_initial_inscription();
        }
        this.taxe = this.compute_taxe();
        this.taxe = parseFloat(this.taxe.toFixed(2));
        this.prix_total = this.prix;
        if (!this.exclude_taxe) {
            this.prix_total += this.taxe;
        }
        this.prix_total = parseFloat(this.prix_total.toFixed(2));

    }

    handle_bib_offer(nb_bib) {
        if (!nb_bib) return;
        this.deleteBibOfferCode();
        if (this.inscriptions.length < nb_bib) return;

        const sortedInscriptionByPrice = this.inscriptions.slice().sort((a, b) => a.get_prix_course() - b.get_prix_course());
        const sortedInscriptionByPriceWithPrice = sortedInscriptionByPrice.filter(inscription => inscription.get_prix_course() > 0 && !inscription.code_reduction);
        const nbTotalInscriptions = this.inscriptions.filter(inscription => inscription.get_prix_course() > 0).length;
        const nbInscriptionsToOffer = Math.floor(nbTotalInscriptions / nb_bib);



        for (let i = 0; i < nbInscriptionsToOffer; i++) {
            const cheapestInscription = sortedInscriptionByPriceWithPrice[i];

            const index = this.inscriptions.findIndex(inscription => inscription == cheapestInscription);
            if (index !== -1) {

                this.inscriptions[index].offer_bib();
            }
        }
    }
    deleteBibOfferCode() {
        for (let i = 0; i < this.inscriptions.length; i++) {

            if (this.inscriptions[i].code_reduction && this.inscriptions[i].code_reduction.nom == "DOSSARD OFFERT") {

                this.inscriptions[i].code_reduction = null;
                this.inscriptions[i].update_cart("code_reduction");
                this.inscriptions[i].compute_cart();
            }

        }
    }


    apply_remise_initial_inscription() {
        if (this.initial_commande_inscription.prix && parseFloat(this.initial_commande_inscription.prix) > 0) {
            this.prix -= parseFloat(this.initial_commande_inscription.prix);
            this.prix = Math.max(0, this.prix);
            this.prix = parseFloat(this.prix.toFixed(2));
        }
    }




    /**
     * Calcule la taxe à appliquer
     *
     * @return {*} 
     * @memberof Reservation
     */
    compute_taxe() {
        if (this.id_module == 63) {
            return custom_hooks.compute_tax_TSV24(this.prix);
        }
        if (this.id_module && this.id_module == 229) {
            return custom_hooks.compute_tax_TSV25(this.prix);
        }

        if (this.id_module && this.id_module == 68) {
            return custom_hooks.compute_tax_CAPVAR24(this.prix);
        }
        if (this.id_module && this.id_module == 85) {
            return custom_hooks.compute_tax_TMB24(this.prix);
        }
        if (this.id_module && this.id_module == 177) {
            return custom_hooks.compute_tax_VTTCAV24(this.prix);
        }
        if (this.id_module && this.id_module == 96) {
            return custom_hooks.compute_tax_ENR24(this);
        }
        if (this.id_module && this.id_module == 250) {
            return custom_hooks.compute_tax_CVRIB25(this.prix);
        }


        // Si le prix est à 0, la taxe est de 0
        if (this.prix == 0) return 0;
        // Si le prix est inférieur à 9, la taxe est de 0,5
        if (this.prix < 9) {
            return 0.5;
        }
        // Si le prix est compris entre 9 et 100, la taxe est de 7% ou 1,2€, ce qu'il y a de plus élevé
        if (this.prix >= 9 && this.prix < 100) {
            let taxe = (this.prix * 7) / 100;
            taxe = Math.max(1.2, taxe);
            return parseFloat(taxe);
        }
        // Si le prix est compris entre 100 et 200, la taxe est de 6%
        if (this.prix >= 100 && this.prix < 200) {
            let taxe = (this.prix * 6) / 100;
            return parseFloat(taxe);
        }
        // Si le prix est supérieur ou égal à 200, la taxe est de 5%
        if (this.prix >= 200) {
            let taxe = (this.prix * 5) / 100;
            return parseFloat(taxe);
        }
    }

    async post() {
        let res = await axios.post("/commande/post.php", this);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.id = res.data.id;
            this.uuid = res.data.uuid;
            return await true;
        }
    }

    async check_availabilities() {
        let res = await axios.post("/commande/check_availabilities.php", this);
        if (res.data.error) {
            return [false, "une erreur est survenue"];
        } else {
            return [res.data.checked, res.data.errors];

        }
    }

    async check_already_paid() {
        let res = await axios.post("/commande/check_already_paid.php", this);
        if (res.data.error) {
            return [false, "une erreur est survenue"];
        } else {
            return [res.data.paid, res.data.errors];

        }
    }

    async post_admin(paiement_admin) {
        this.paiement_admin = paiement_admin;
        let res = await axios.post("/commande/post_admin.php", this);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.id = res.data.id;
            this.uuid = res.data.uuid;
            return await true;
        }
    }

    async post_changement_parcours() {
        let res = await axios.post("/commande/post_changement_parcours.php", this);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            this.id = res.data.id;
            this.uuid = res.data.uuid;
            return await true;
        }
    }

    generate_uuid() {
        if (!this.uuid) {
            this.uuid = Math.floor(Math.random() * Date.now())
        }
        else {
            console.log("UUID already generated");
        }

    }

    assign_coureur() {
        for (let i = 0; i < this.inscriptions.length; i++) {
            if (this.inscriptions[i].coureur) {
                this.inscriptions[i].coureur.id_utilisateur = this.id_account;
            }
        }
    }

    async set_paid_free_checkout() {
        let data = { "uuid": this.uuid };
        let res = await axios.post("/lyra_payment/free_checkout.php", data);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            return await true;
        }
    }

    async set_paid_free_checkout_changement_parcours() {
        let data = { "uuid": this.uuid };
        let res = await axios.post("/lyra_payment/free_checkout_changement_parcours.php", data);
        if (res.data.error) {
            console.log(res.data.error);
            return await false;
        } else {
            return await true;
        }
    }

    is_valid() {
        let response = { "valid": true, "message": "" };

        if (this.nb_articles == 0) {
            response.valid = false;
            response.message = "Votre panier est vide, vous ne pouvez pas valider votre commande";
        }
        if (this.inscriptions.length == 0) {
            response.valid = false;
            response.message = "Votre panier est vide, vous ne pouvez pas valider votre commande";
        }

        for (let i = 0; i < this.inscriptions.length; i++) {

            if (!this.inscriptions[i].coureur || !this.inscriptions[i].coureur.champs || !this.inscriptions[i].coureur.champs.mail) {
                response.valid = false;
                response.message = "Une erreur est survenu lors de l'inscription d'un participant, vous devez renseigner un email pour chaque participant";
                return response;
            }
            if (Object.keys(this.inscriptions[i].coureur.champs).length === 0) {
                response.valid = false;
                response.message = "Une erreur est survenu lors de l'inscription d'un participant, veuillez vérifier les informations saisies à l'étape précedente";
                return response;
            }
            if (this.inscriptions[i].coureur.champs.mail.value == "") {
                response.valid = false;
                response.message = "Une erreur est survenu lors de l'inscription d'un participant, vous devez renseigner un email pour chaque participant";
                return response;
            }
        }
        return response;
    }



}